import { ConsumablesMasterThemeSizeConfig } from './types';

const large: ConsumablesMasterThemeSizeConfig = {
  consumablesMaster: {},
};

export default large;
